import React from 'react'
import { get } from 'lodash'
import popup from '../../popup'
import './style.css'
import { forgotPassword } from '~/redux/user/helpers';

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    if (this.state.forgotPasswordSuccess)
      return (this.successScreen())

    return (
      <div className="forgot-password centered">
        <img className="mobile-logo-image" src={ get(window.settings, 'images.desktopLogo') } alt="logo"/>
        <div className="mobile-heading">Forgot password</div>
        <span className="intro"> Enter your email address below and we will send you a link to reset your password.</span>
        <div className="input-box">
          <input
            type="text"
            placeholder="EMAIL"
            ref={ i => { this.forgotPasswordInput = i} }
            onKeyPress={ e => {
              if (e.key === 'Enter') this.submitForgotPassword()
            } }
            />
        </div>
        <div className="error-box">{ this.state.forgotPasswordError || '' }</div>

        <button
          className={ `button cta submit-button ${ this.state.buttonProgress ? 'disabled' : '' }` }
          onClick={ e => { this.submitForgotPassword() } }>
            { this.state.buttonProgress ? '...' : 'Email Me' }
        </button>
        <div className="back-button" onClick={ e => { this.props.args ? popup.hide() : popup.login() } }> Back </div>
      </div>
    )
  }

  successScreen() {
    return (
      <div className="forgot-password centered">
        <span className="intro"> An email has been sent to recover your password. </span>
      </div>
    )
  }

  submitForgotPassword() {
    this.setState({...this.state, forgotPasswordError: null, buttonProgress: true })

    forgotPassword(this.forgotPasswordInput.value).then( res => {
      var emailSent = res.data && res.data.emailSent
      var error = res.data && res.data.error

      this.setState({
        ...this.state,
        forgotPasswordError: null,
        buttonProgress: false,
        forgotPasswordSuccess: emailSent
      })

      if (!emailSent)
        this.forgotPasswordAlert(
          error || 'There was an error sending email. Please try again later.'
        )

    }).catch( e => {
      this.setState({...this.state, buttonProgress: false })
      var message =
        (((e || {}).response || {}).data || {}).error ||
        'There was an error processing your request.'
      this.forgotPasswordAlert(message)
    })
  }

  forgotPasswordAlert(txt) {
    this.setState({...this.state, forgotPasswordError: txt })
    setTimeout( _ => { this.setState({...this.state, forgotPasswordError: null }) }, 5000)
  }
}

export default ForgotPassword;
